import React, { useEffect, useState } from "react";
import "./ReferAndEarn.css";
import { Form, InputGroup } from "react-bootstrap";
import { myaccountForm } from "../../features/my_account/Slice";
import { useDispatch, useSelector } from "react-redux";

const ReferAndEarn = () => {
  const [activeTab, setActiveTab] = useState("refer");

  const referralData = [
    { id: 1, name: "Tejas Langote", amount: "10378.00", hasDeposited: true },
    { id: 2, name: "Simba Don", amount: "0.00", hasDeposited: false },
    { id: 3, name: "ANIL NARKHEDE", amount: "0.00", hasDeposited: false },
    { id: 4, name: "Harshal Narkhede", amount: "0.00", hasDeposited: false },
    { id: 5, name: "Sachin Bharambe", amount: "100000.00", hasDeposited: true },
  ];

  const handleShare = () => {
    // Share logic
    if (navigator.share) {
      navigator.share({
        title: "Join and Earn",
        text: "Join using my referral link and start earning!",
        url: "http://localhost:3001",
      });
    }
  };

  const handleCall = (name) => {
    // Call functionality
   
  };
  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    dispatch(myaccountForm());
  }, [dispatch]);

  const handleCopy = () => {
    navigator.clipboard.writeText(user?.refer_code);
    alert("Referral link copied!");
  };
 

  return (
    <section className="ReferAndEarn ">
      <div className="custom_container">
        <div className="mobile-container">
          {/* Main Content */}
          <div className="main-content">
            {/* Hero Section */}
            <div className="hero-section">
              <div className="hero-illustration">
                <img
                  src="/assets/Images/ReferAndEarn/Referral-Program-min.png"
                  alt="Referral illustration"
                  className="hero-image"
                />
              </div>
            </div>

            {/* Earning Info */}
            <div className="earning-section">
              <div className="earning-title">
                <span className="percentage">₹100</span>
                <div className="earning-text">
                  <div className="monthly">off</div>
                  <div className="earning">on your next order</div>
                </div>
              </div>
              <div className="earning-subtitle">
                Enjoy a discount on your next purchase!
              </div>
            </div>

            {/* Referred code */}
            <div className="stats-section">
              <div className="stats-container">
                <div className="stat-item">
                  <div className="stat-label">Referral Codes</div>
                  <div className="stat-value referred">{user?.refer_code}</div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              <button className="action-btn copy-btn" onClick={handleCopy}>
                <span className="btn-icon">📋</span>
                Copy
              </button>
              <button className="action-btn share-btn" onClick={handleShare}>
                <span className="btn-icon">📤</span>
                Share
              </button>
            </div>

            {/* Stats Section */}
            <div className="stats-section">
              <div className="stats-container">
                <div className="stat-item">
                  <div className="stat-label">Total Referred</div>
                  <div className="stat-value referred">{user.refer.length}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferAndEarn;
